import { Box, Typography } from "@mui/material";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid";
import { useCallback, useEffect, useRef, useState } from "react";
import LoadingIndicator from "../components/LoadingIndicator";
import StoragesTable from "../components/Storages/StoragesTable";
import { PaginationModel, QueryOptions } from "../interfaces/pagination";
import { Storage } from "../interfaces/storage";
import { useAllStorages } from "../services/storages";
import PageTitle from "../components/PageTitle";

const StoragesPage = () => {
  const [storages, setStorages] = useState<Storage[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [paginationModel, setPaginationModel] = useState<PaginationModel>({
    page: 0,
    pageSize: 100,
  });

  const [rowCount, setRowCount] = useState<number>(storages.length);

  const [queryOptions, setQueryOptions] = useState<QueryOptions>({});

  const timeoutRef = useRef<number | null>(null);

  const handleFilterModelChange = useCallback(
    (filterModel: GridFilterModel) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = window.setTimeout(() => {
        setQueryOptions((prev) => {
          if (
            filterModel.quickFilterValues &&
            filterModel.quickFilterValues.length > 0
          ) {
            setPaginationModel((prev) => ({
              ...prev,
              page: 0,
            }));

            const search = filterModel.quickFilterValues.join(" ");
            return { ...prev, search };
          } else {
            const { search, ...others } = prev;
            return others;
          }
        });
      }, 300);
    },
    []
  );

  const handleSortModelChange = useCallback((sortModel: GridSortModel) => {
    setQueryOptions((prev) => {
      if (sortModel.length > 0) {
        setPaginationModel((prev) => ({
          ...prev,
          page: 0,
        }));

        const ordering = `${sortModel[0].sort === "desc" ? "-" : ""}${
          sortModel[0].field
        }`;
        return { ...prev, ordering };
      } else {
        const { ordering, ...others } = prev;
        return others;
      }
    });
  }, []);

  const { data: storagesData, isLoading: isStroagesDataLoading } =
    useAllStorages({
      ...paginationModel,
      ...queryOptions,
    });

  useEffect(() => {
    if (storagesData) {
      setStorages(storagesData.results);
    } else {
      setStorages([]);
    }
    setIsLoading(false);

    setRowCount((prevRowCount) =>
      storagesData ? storagesData.count : prevRowCount
    );
  }, [storagesData]);

  return (
    <>
      <PageTitle title="Storages" />
      <Box sx={{}}>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <StoragesTable
            storages={storages}
            rowCount={rowCount}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleFilterModelChange={handleFilterModelChange}
            handleSortModelChange={handleSortModelChange}
            isLoading={isStroagesDataLoading}
          />
        )}
      </Box>
    </>
  );
};

export default StoragesPage;
